import React from "react";
import { useSelector } from "react-redux";
import { StyleSheet, View } from "react-native";
import i18n from "utils/i18n";
import { dataConstants } from "services/redux/data/constants";
import ThemedSafeAreaComponentTop from "components/atoms/ThemedSafeAreaTop";
import ThemedLayout from "components/atoms/ThemedLayout";
import Translate from 'utils/translate'
import _ from 'lodash';
import ManagementDashboardComponentMeetingRooms from "./components/buildingMeetingRooms";
import TabbedContent from 'components/molecules/TabbedContent'
import Divider from 'theme/Divider';
import ManagementDashboardComponentBuilding from "./components/building";
import ObjectBuilding from 'utils/objects/building'
import HelperString from 'utils/helper-string'
import { useShowHamburger } from 'utils/helper-device'


const ManagementDashboardIndexScene = () => {
	
	const showHamburger = useShowHamburger();
	
	const _buildings = useSelector( state => {
		return state.data[dataConstants.BUILDINGS];
	} )

	const tabBarItems = [];
	_.forEach( ObjectBuilding.filterAndOrder( _buildings ), ( building ) => {
		tabBarItems.push( {
			key: building.guid,
			text: Translate.field( building, 'title' ),
			scene: ( props ) => {
				return (
					<RenderBuilding
						{ ...props }
						building={ building }
	            />
				);
			}
		});
	})
	
	return (
		<ThemedSafeAreaComponentTop
			top={ false }>

			<ThemedLayout
				title={i18n.t('management:pages.presence.index.title')}
				topNavigation={ true }
				topNavigationProps={{
					showHamburgerDrawer: showHamburger
				}}>
				
				<TabbedContent
					items={ tabBarItems }
				/>
			</ThemedLayout>
		</ThemedSafeAreaComponentTop>
	);
}

const RenderBuilding = ({ building }) => {
	
	return (
		<View
			key={ HelperString.hash( `building-view`, building ) }>
			
			{/* Building charts */}
			<ManagementDashboardComponentBuilding
				building={ building }
			/>
			
			<Divider
				style={ staticStyles.dividerMarginVertical20MarginHorizontal10 }
			/>
			
			{/* Big meeting room component */}
			<ManagementDashboardComponentMeetingRooms
				building={ building }
			/>
		</View>
	);
}

const staticStyles = StyleSheet.create({
	dividerMarginVertical20MarginHorizontal10: {
		marginVertical: 20,
		marginHorizontal: 10,
	},
});

export default ManagementDashboardIndexScene
